module.exports = __webpack_public_path__ + "static/img/Frame 1823.c3d61e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/Frame 1823.png
// module id = O8Yd
// module chunks = 12